import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import { setCliente } from "redux/features/cliente/cliente-slice";

import "./style.css";
import { SecurityPageProps } from "models/security";
import { showMessage } from "utils/messages";
import Endpoints from "services/api/endpoints";
import useApi, { ApiMethod } from "hooks/useApi";
import {
  LOCAL_STORE_CLIENTE,
  LOCAL_STORE_ID_USUARIO,
  LOCAL_STORE_ITOKEN,
  LOCAL_STORE_THEME,
  LOCAL_STORE_TOKEN_BEARER,
} from "../../../constants";
import { saveItemLocalStore, getItemLocalStore } from "utils/storeUtils";
import { setLoading } from "redux/ui/loadings-slice";
import { cpfUnmask } from "utils/mask";
import KeyboardWrapper from "components/Keyboard";
import Input from "components/input";
import ContainerFlex from "components/ContainerFlex";

const ClienteCPF: React.FC<SecurityPageProps> = ({
  title,
  subDescription,
  description = "",
  nextStep,
  backStep,
}) => {
  const [input, setInput] = useState("");
  const [value, setValue] = useState("");

  const keyboard = useRef(null);

  // Recuperando da rota a opção de usuário por segunda via
  const history = useHistory();
  const dispatch = useAppDispatch();
  const {
    cliente: { cliente },
  } = useAppSelector((state) => state);
  const { dadosLogin } = getItemLocalStore(LOCAL_STORE_CLIENTE);

  useEffect(() => {
    if (input.length <= 6) {
      setValue(input);
    }
  }, [input]);

  const handleSubmit = async () => {
    dispatch(setCliente({ ...cliente, senha: value }));

    if (value.length === 6) {  
      dispatch(setLoading(true));
      try {
        const requestToken = await getTokenCliente.callApi({
          cpf: cpfUnmask(cliente.cpf) || "",
          senha: value,
          origem: "TOTEM",
        });

        if (
          requestToken.status >= 200 &&
          requestToken.status < 300 &&
          requestToken.data?.token
        ) {
          const dadosCliente = getItemLocalStore(LOCAL_STORE_CLIENTE);
          saveItemLocalStore(LOCAL_STORE_CLIENTE, {
            ...dadosCliente,
            dadosLogin: requestToken.data,
          });
          saveItemLocalStore(
            LOCAL_STORE_THEME,
            requestToken.data?.modeloTemaCartao || "RED",
          );

          localStorage.setItem(LOCAL_STORE_ITOKEN, requestToken.data.token);
          localStorage.setItem(
            LOCAL_STORE_TOKEN_BEARER,
            requestToken.data.novoToken,
          );
          localStorage.setItem(LOCAL_STORE_ID_USUARIO, requestToken.data.id);

          history.push(nextStep);
          dispatch(setLoading(false));
        } else {
          dispatch(setLoading(false));
          const mensagem = requestToken.data?.mensagem;
          showMessage(
            "warning",
            "Atenção!",
            mensagem || "Não foi possível autenticar o cartão. Tente novamente.",
          );
        }
      } catch (err) {
        dispatch(setLoading(false));
        showMessage(
          "warning",
          "Atenção!",
          "Não foi possível se comunicar com o servidor.",
        );
      }
    } else {
      showMessage("warning", "Atenção!", "A senha deve conter 6 dígitos", {
        timer: 9000,
        showConfirmButton: false,
      });
    }
  };

  const getTokenCliente = useApi<any>(
    Endpoints.usuario.loginCliente,
    ApiMethod.POST,
  );

  useEffect(() => {
    if (dadosLogin?.token) {
      history.push(nextStep);
    }
  }, [dadosLogin?.token, history, nextStep]);

  return (
    <div className="container">
      <h1>{title}</h1>

      {subDescription && (
        <h2 dangerouslySetInnerHTML={{ __html: subDescription }}></h2>
      )}

      <div
        className="container-description"
        dangerouslySetInnerHTML={{ __html: description }}
      />

      <ContainerFlex width={60}>
        <ContainerFlex marginBottom={10}>
          <Input
            name="password"
            id="password"
            type="password"
            label="Valor"
            style={{
              height: "15%",
              textAlign: "center",
              fontSize: "20px",
              fontWeight: "bold",
            }}
            value={value}
            maxLength={6}
            onChange={(e) => setValue(e)}
            edit
            disabled
          />
        </ContainerFlex>
        <KeyboardWrapper
          onPressBack={() => history.push(backStep)}
          keyboardRef={keyboard}
          onChange={setInput}
          typeKeyboard="numeric"
          onPressEnter={() => handleSubmit()}
        />
      </ContainerFlex>
    </div>
  );
};

export default ClienteCPF;
